import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './hooks/useAuth'  // ajusta la ruta si es necesario
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Clientes from './pages/Clientes'
import ClienteDetalle from './pages/ClienteDetalle'
import Servicios from './pages/Servicios'
import Layout from './components/Layout'
import Toast from './components/Toast'  // <-- nuevo

function App() {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Cargando aplicación...</p>
        </div>
      </div>
    )
  }

  return (
    <BrowserRouter>
      <Toast /> {/* ← aquí aparecerán las notificaciones */}
      <Routes>
        <Route path="/login" element={!user ? <Login /> : <Navigate to="/" replace />} />
        <Route element={<Layout />}>
          <Route path="/" element={user ? <Dashboard /> : <Navigate to="/login" replace />} />
          <Route path="/clientes" element={user ? <Clientes /> : <Navigate to="/login" replace />} />
          <Route path="/clientes/:id" element={user ? <ClienteDetalle /> : <Navigate to="/login" replace />} />
          <Route path="/servicios" element={user ? <Servicios /> : <Navigate to="/login" replace />} />
        </Route>
        <Route path="*" element={<Navigate to={user ? "/" : "/login"} replace />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
